/**
 * Formats business entity names by capitalizing common business entity abbreviations
 * 
 * @param {string} name - The entity name to format
 * @returns {string} - The formatted entity name with proper capitalization
 */
export function formatEntityName(name) {
    if (!name || typeof name !== 'string') {
        return name;
    }

    // Common business entity abbreviations that should be capitalized
    const entityAbbreviations = [
        'llc',
        'ltd',
        'inc',
        'corp',
        'co',
        'lp',
        'llp',
        'pllc',
        'pc',
        'pa',
        'dba',
        'dmd',
        'md',
        'dds',
        'cpa',
        'esq'
    ];

    // Create a more robust replacement approach
    let result = name;
    
    // Handle each entity abbreviation individually for better control
    entityAbbreviations.forEach(abbr => {
        // Create regex for the abbreviation (case insensitive, word boundaries)
        const regex = new RegExp(`\\b${abbr}\\b`, 'gi');
        result = result.replace(regex, abbr.toUpperCase());
        
        // Also handle dotted versions (L.L.C., I.N.C., etc.)
        const dottedRegex = new RegExp(`\\b${abbr.split('').join('\\.?')}\\b`, 'gi');
        result = result.replace(dottedRegex, abbr.toUpperCase());
    });
    
    return result;
}
